import TicketSelector from '../../../events/detail/TicketSelector';

class FlexDetailsTicketSelector extends TicketSelector {
  constructor({ onSubmit }) {
    const $form = document.querySelector('#flex-form-pricetype-quantities');

    super($form, { selectedZoneId: '1' });

    this.form.addEventListener('submit', this.preFormSubmit);

    this.onFormSubmit = (event) => {
      onSubmit(event);
    };
  }
}

export default FlexDetailsTicketSelector;
